import Vue from 'vue';
if(document.getElementById('join-stream')){
    let joinStream = new Vue({
        el: '#join-stream-page',
        data: {
            confidentiality: true,
            entryBlock: true,
        },
        mounted() {
            let self = this;
            let streamJoin = {
                countrySelect: $(".select2-country-search"),
                citySelect: $(".select2-city-search"),
                orgSelect: $(".select2-org-search"),
                byNameSelect: $(".select2-byname-search"),
                orgUsersNode: $("#org-users"),
                userListNode: $("#user-list"),
                users:{},
                init:function(){
                    var self = this;
                    this.citySelect.select2({
                        placeholder: "Введите город",
                        theme: 'select-city',
                        allowClear: true,
                        doReset:true,
                        templateResult: function (data) {
                            if (data.region) {
                                return data.text + ", " + data.region;
                            }

                            return data.text;
                        },
                        ajax: {
                            url: "/data/city-list",
                            data: function (params) {
                                var query = {
                                    q: params.term,
                                    country: country
                                };
                                return query;
                            },

                            cache: true
                        }
                    });

                    this.orgSelect.select2({
                        placeholder: "Введите ЛПУ",
                        theme: 'select-city',
                        minimumInputLength: 3,
                        allowClear: true,
                        doReset:true,
                        templateResult: function (data) {
                            return data.text;
                        },
                        ajax: {
                            url: "/data/org-list",
                            data: function (params) {
                                var query = {
                                    q: params.term,
                                    country: country,
                                    city: city,
                                    addother:0
                                };
                                return query;
                            },

                            cache: true
                        }
                    });
                    this.byNameSelect.select2({
                        placeholder: "Поиск по фамилии или телефону",
                        minimumInputLength: 1,
                        theme: 'select-city',
                        templateResult: function (data) {

                            if(data.phone){

                                return data.text + " " + data.phone;

                            } else {

                                return data.text;
                            }

                        },
                        allowClear: true,
                        doReset:true,
                        ajax: {
                            url: "/data/find-users",
                            data: function (params) {
                                let query = {
                                    q: params.term
                                };
                                return query;
                            },
                            cache: true
                        }
                    });

                    this.countrySelect.select2({
                        placeholder: "Введите страну",
                        theme: 'select-city',
                        allowClear: true,
                        doReset:true
                    });

                    this.citySelect.on('select2:select',function(e){

                        let city = $(this).val();

                    }).on('change',function(e){
                        self.orgSelect.empty();
                    });

                    this.countrySelect
                        .on('select2:select',function(e){
                            let country = $(this).val();
                        })
                        .on('change',function(e){
                            self.citySelect.empty();
                            self.orgSelect.empty();
                        });

                    this.orgSelect
                        .on('change',function(e){
                            self.getUsers();
                        });

                    this.byNameSelect
                        .on('select2:select',function(e){

                            self.addUser(
                                $(this).val(),
                                $(this).text().trim()
                            );
                            self.byNameSelect.empty();
                        });

                },
                getUsers:function(){

                    let self = this;
                    $.ajax({
                        url: '/data/users-list',
                        dataType: "json",
                        data:{
                            org_id:self.orgSelect.val()
                        },
                        success: function (data) {
                            var insertHtml = '';
                            $.each(data,function (id,name) {
                                insertHtml += '<li data-user-id="'+id+'" data-user-fullname="'+name+'">'+'<span class="fa fa-user-circle"></span>'+'<span class="fa fa-plus-circle"></span>'+name+'</li>';
                            });

                            self.orgUsersNode.html(insertHtml);

                        },
                        fail: function () {

                            throw new Error('Ошибка получении данных');

                        }
                    });

                },
                addUser:function(id,name){

                    if(!(this.users.hasOwnProperty(id))){

                        let insertHtml = '<li data-user-id="'+id+'">'+name+'<i class="fa fa-minus-circle" aria-hidden="true"></i></li>';

                        this.users[id] = {
                            id:id,
                            name:name

                        };

                        this.userListNode.append(insertHtml);

                    } else{

                        return false;

                    }

                },
                removeUser:function(id){

                    if((this.users.hasOwnProperty(id))){

                        this.userListNode.find('[data-user-id='+id+']').remove();

                        this.orgUsersNode.find('[data-user-id='+id+']').show();

                        delete this.users[id];

                    } else{

                        return false;

                    }

                },
                join:function(){
                    let self = this;
                    $.ajax({
                        url: location.href,
                        type: "POST",
                        data:  {'users[]':Object.keys(self.users),join:'join', _csrf:$("meta[name=csrf-token]").attr("content")},
                        success: function(data) {

                        },
                        error:  function(jqXHR, textStatus, errorThrown ) {

                        }
                    });
                },
                registrationUser:function(data){
                    let self = this;
                    $.ajax({
                        url: '/user/registration/fast-register',
                        type: "POST",
                        data:  data,
                        contentType: false,
                        cache: false,
                        processData:false,
                        success: function(data) {

                            self.addUser(data.user_id,data.name);
                            $("#add-user")[0].reset();
                            $('html, body').animate({
                                scrollTop: $(".reg-lecture").offset().top
                            }, 2000);
                        },
                        error:  function(jqXHR, textStatus, errorThrown ) {

                        }
                    });
                }

            };
            jQuery(document).ready(function(){
                    streamJoin.init();
                })
                .on('click','#org-users li',function () {
                    let $el = $(this);
                    streamJoin.addUser($el.data('user-id'),$el.data('user-fullname'));
                    $el.hide();
                })
                .on('click','#user-list li',function () {
                    let $el = $(this);
                    streamJoin.removeUser($el.data('user-id'));
                })
                .on('submit','#add-user',function (event) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    streamJoin.registrationUser( new FormData($(this)[0]));
                })
                .on('click','.join',function () {
                    streamJoin.join();
                    console.log('rgrg')

                });

        },
        methods: {
            cleanData() {
                this.confidentiality = !this.confidentiality;
            }

        }
    });
}




